export default __webpack_public_path__ + "static/media/logo-youtube.a8c8a7ba.svg";